import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { WidgetService } from "../shared/services/widget/widget.service";
import { Widget, DataFilter } from "../shared/interface/widget";

@Component({
  selector: 'app-public-dashboard',
  templateUrl: './public-dashboard.component.html',
  styleUrls: ['./public-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PublicDashboardComponent implements OnInit {
  widgetList = [];
  othersWidgetList = [];
  countsWidgetList = [];
  widgetListGroup = [];


  constructor(
    private widgetService: WidgetService
  ) { }

  ngOnInit() {

    this.setWidget();
  }

  setWidget(){

    this.widgetService.publicWidget().subscribe(res => {
      this.widgetList = res;
      this.widgetListGroup = [];
      //get widgets other than box type
      this.othersWidgetList = this.widgetList.filter(widget => widget.fetchDataFor !== 'box');
      //get widgets of box type
      this.countsWidgetList = this.widgetList.filter(widget => widget.fetchDataFor === 'box');
      
      let cl = this.countsWidgetList.length;
      let l = this.othersWidgetList.length;
      if (cl > 0) {
        let g: any = [];
        for (let i = 0; i < cl; i = i + 4) {
          g = this.countsWidgetList.slice(i, i + 4);
          this.widgetListGroup.push(g);
        }
      }
      if (l > 0) {
        let g: any = [];
        for (let i = 0; i < l; i = i + 2) {
          g = this.othersWidgetList.slice(i, i + 2);
          this.widgetListGroup.push(g);
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/public-dashboard/public-dashboard.component.ts